export default __webpack_public_path__ + "static/media/price-list-small.27851658.svg";